// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"265d64b9","22":"4cf97d0f","52":"3b71d728","208":"b3522917","787":"eb09adb9"}[chunkId] + ".chunk.js";
};